export default __webpack_public_path__ + "static/media/lesson-plan-math-instruments.c528797a.png";